module.exports = __webpack_public_path__ + "img/top_logo.faec3ce0.png";